import React from "react";

import { Chip, Stack, Typography } from "@mui/material";

import type { ManagedResourceUI } from "@domains/resource/types";

export interface ResourceAttachmentProps {
  resources: ManagedResourceUI[];
  selectedIds: number[];
  onToggle: (resourceId: number) => void;
}

export function ResourceAttachment({
  resources,
  selectedIds,
  onToggle,
}: ResourceAttachmentProps): React.ReactElement {
  if (resources.length === 0) {
    return (
      <Typography variant="caption" color="text.secondary">
        No resources available. Create databases, caches, or queues first.
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
      {resources.map((r) => {
        const selected = selectedIds.includes(r.id);
        return (
          <Chip
            key={r.id}
            label={`${r.name} (${r.resourceType})`}
            size="small"
            variant={selected ? "filled" : "outlined"}
            color={selected ? "primary" : "default"}
            onClick={() => onToggle(r.id)}
            sx={{ cursor: "pointer" }}
          />
        );
      })}
    </Stack>
  );
}
